// Extra costs configuration for advanced pricing mode
export const EXTRA_COSTS_YEARLY = {
  social: 40, // Cost per additional social account page per year
  users: 20, // Cost per additional user per year
  sources: 20 // Cost per additional source per year
}

// Threshold for automatic plan upgrade (in euros)
export const UPGRADE_THRESHOLD = 200

export default EXTRA_COSTS_YEARLY
